import styled from 'styled-components';

const CrowdDetailStyle = styled.div`
  .crowd_detail {
    display: flex;
    flex-direction: column;
  }
`;

export default CrowdDetailStyle;
